module.exports = __webpack_public_path__ + "img/20210610-IMG_04591.2028d96f.jpg";